import { getTranslatedText } from '@nile/components';

// input will be in the format which has different types of recepients in to, cc, bcc section.
// They need common format in select dropdown. This method achieves the same.
const preFormatInputForDropdownState = (inputArray, intl) => {
  const formattedData = inputArray.map((el) => {
    if (el.type === 'PLACEHOLDER') {
      return {
        value: el.placeHolder,
        label: getTranslatedText(intl, el.placeHolder)
      };
    }
    if (el.type === 'USER') {
      return {
        userId: el.user?.userId,
        value: el.user?.email,
        email: el?.user?.email,
        label: `${el.user?.firstName} ${el.user?.lastName || ''}`
      };
    }
    if (el.type === 'EMAIL') {
      return {
        name: el.email,
        value: el.email,
        label: el.email,
        isEmail: true
      };
    }
    return {};
  });
  return formattedData;
};

const preFormatDataForMentionsLibrary = (inputArray, intl, titleKey) => {
  const formattedData = inputArray?.map((el) => {
    const fields = el?.fields?.map((field) => {
      const label = getTranslatedText(intl, field);
      return {
        display: label,
        id: field,
        key: field,
        label: label,
        placeholderValue: field,
        text: label,
        url: field,
        value: label
      };
    });

    const customFields = (el?.customFields ?? []).map(({ key, label }) => {
      return {
        display: label,
        id: key,
        key: key,
        label: label,
        placeholderValue: label,
        text: label,
        url: label,
        value: label
      };
    });

    return {
      title: getTranslatedText(intl, el?.[titleKey || 'name']),
      fields: [...fields, ...customFields]
    };
  });
  return formattedData;
};

// We get the placeholders from backend with i18n keys. We get the translated label here.
// They are received as keys because we requested it in that format as it is the same key which
// should be sent if the user selects the placeholder/mentions them.

const getTranslatedStringsForMetaPlaceholders = (inputArray, intl) => {
  const formattedData = inputArray.map((placeholder) => ({
    ...placeholder,
    label: getTranslatedText(intl, placeholder.value),
    name: placeholder.value
  }));
  return formattedData;
};

export {
  preFormatInputForDropdownState,
  preFormatDataForMentionsLibrary,
  getTranslatedStringsForMetaPlaceholders
};
